export default __webpack_public_path__ + "static/live-cards-bb986d51f239a1ce6ce6c02224d65d3f.avif";